import { useQuery } from "react-query";
import tenantApi from "../utils/api/tenant";


export function useTenantFeature(enabled = true) {
    return useQuery("tenantFeatures", () => tenantApi.features.getTenantFeature(), {
        enabled,
    });
}
